"use memo"

import dayjs from 'dayjs'
import { useCallback, useEffect, useMemo } from 'react'
import { AgxSpacer } from '@urbanx/agx.ui-components2'
import { AgreementType } from '@urbanx/agx.campaigns.client'
import { TaskModalPageProps } from '../TaskModalPageProps'
import QLDAgreementTypeStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/QLD/QLDAgreementTypeStageSteps'

const QldAgreementComplianceTypePage = ({
  task,
  toggleTaskStep,
  agreementDetails,
  onAgreementDetailsUpdated,
  isAgreementTypeOpen,
  agreementExceededGap,
}: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps])

  const computedValues = useMemo(() => {
    if (!agreementDetails) {
      return []
    }

    const isOpen = agreementDetails.agreementType === AgreementType.Open
    const hasStart = Boolean(agreementDetails.startDate)
    const hasEnd = Boolean(agreementDetails.endDate)
    const diffOk =
      isOpen ||
      dayjs(agreementDetails.endDate).diff(
        dayjs(agreementDetails.startDate),
        'day'
      ) <= 90

    return [hasStart, isOpen ? true : hasEnd, diffOk]
  }, [agreementDetails])

  useEffect(() => {
    if (computedValues.length === 0) {
      return
    }

    computedValues.forEach((value, index) => {
      const step = taskSteps[index]
      if (!step || step.isCompleted === value) {
        return
      }

      toggleTaskStep(step.order ?? 0, value)
    })
  }, [computedValues, taskSteps, toggleTaskStep])

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked)
    },
    [toggleTaskStep]
  )

  if (!agreementDetails || !onAgreementDetailsUpdated) {
    return null
  }

  return (
    <AgxSpacer direction="vertical" fill>
      <QLDAgreementTypeStageSteps
        agreementDetails={agreementDetails}
        onAgreementDetailsUpdated={onAgreementDetailsUpdated}
        isOpen={Boolean(isAgreementTypeOpen)}
        exceededGap={Boolean(agreementExceededGap)}
        tasksStage2={taskSteps}
        updateTaskStep2={updateTaskStep}
      />
    </AgxSpacer>
  )
}

export default QldAgreementComplianceTypePage
